import { useState } from "react";
import { format, parseISO, isValid } from "date-fns";
import { CalendarIcon, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/lib/utils";

export function DatePicker({ value, onChange, testId, placeholder = "Pick a date", disabled }) {
  const [open, setOpen] = useState(false);
  const d = value ? parseISO(value.slice(0, 10)) : null;
  const valid = d && isValid(d);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <div className="relative">
        <PopoverTrigger asChild>
          <Button type="button" variant="outline" disabled={disabled} data-testid={testId} className={cn("w-full justify-start font-normal h-9 px-3", valid && "pr-8", !valid && "text-muted-foreground")}>
            <CalendarIcon size={14} className="mr-2 shrink-0" />
            <span className="flex-1 text-left truncate">{valid ? format(d, "d MMM yyyy") : placeholder}</span>
          </Button>
        </PopoverTrigger>
        {valid && !disabled && <button type="button" aria-label="Clear date" data-testid={testId ? `${testId}-clear` : undefined} onClick={() => onChange("")} className="absolute right-2 top-1/2 -translate-y-1/2 rounded p-0.5 opacity-60 hover:opacity-100 hover:bg-muted"><X size={12} /></button>}
      </div>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" selected={valid ? d : undefined} defaultMonth={valid ? d : undefined} onSelect={(day) => { onChange(day ? format(day, "yyyy-MM-dd") : ""); setOpen(false); }} initialFocus />
      </PopoverContent>
    </Popover>
  );
}
